import React from 'react'
import './Aboutkaramale.css'
import { Link } from 'react-router-dom'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import { API_URL } from './config'

class Aboutkaramale extends React.Component {
  componentDidMount() {
    document.title = 'Karamale - About Karamale'
  }

  render() {
    const isPartner = localStorage.getItem('partnerid') !== null

    const dashboardImage = `${API_URL}/apps/kscanner/icons/dashboard.jpeg`
    const createEventImage = `${API_URL}/apps/kscanner/icons/createevent.jpeg`
    const eventListedImage = `${API_URL}/apps/kscanner/icons/eventlisted.jpeg`

    const revenueImage = `${API_URL}/apps/kscanner/icons/revenue.jpeg`
    const salesImage = `${API_URL}/apps/kscanner/icons/salesprogress.jpeg`
    const performanceImage = `${API_URL}/apps/kscanner/icons/performance.jpeg`

    return (
      <div className="kx-about">
        {isPartner ? <Header5 /> : <Header />}

        {/* HERO */}
        <section className="kx-about__hero">
          <div className="kx-about__hero-inner">
            <div className="kx-about__hero-copy">
              <div className="kx-about__eyebrow">
                <span></span>
                THE EVENT PLATFORM
              </div>

              <h1>
                Selling tickets
                <br />
                <strong>made easy.</strong>
              </h1>

              <p>
                Create, launch and manage your events from one simple platform. Sell tickets, reach
                your audience and keep your event moving.
              </p>

              <div className="kx-about__hero-actions">
                <Link to="/organiser-registration" className="kx-about__button">
                  Start selling
                  <span>→</span>
                </Link>

                <a href="#how-it-works" className="kx-about__text-link">
                  See how it works
                  <span>↓</span>
                </a>
              </div>
            </div>

            <div className="kx-about__hero-visual">
              <div className="kx-about__hero-card">
                <div className="kx-about__hero-card-top">
                  <span>ORGANISER DASHBOARD</span>
                  <span className="kx-about__live">
                    <i></i> LIVE
                  </span>
                </div>

                <div className="kx-about__hero-stat">
                  <span>Ticket revenue</span>
                  <strong>R48,620</strong>
                  <small>+18.4% this month</small>
                </div>

                <div className="kx-about__hero-chart">
                  <span style={{ height: '32%' }}></span>
                  <span style={{ height: '46%' }}></span>
                  <span style={{ height: '39%' }}></span>
                  <span style={{ height: '58%' }}></span>
                  <span style={{ height: '51%' }}></span>
                  <span style={{ height: '72%' }}></span>
                  <span style={{ height: '65%' }}></span>
                  <span style={{ height: '84%' }}></span>
                  <span style={{ height: '76%' }}></span>
                  <span style={{ height: '94%' }}></span>
                </div>

                <div className="kx-about__hero-card-footer">
                  <div>
                    <span>Tickets sold</span>
                    <strong>1,248</strong>
                  </div>

                  <div>
                    <span>Events</span>
                    <strong>12</strong>
                  </div>

                  <div>
                    <span>Attendance</span>
                    <strong>86%</strong>
                  </div>
                </div>
              </div>

              <div className="kx-about__floating-card kx-about__floating-card--one">
                <span>Tickets sold</span>
                <strong>+248</strong>
              </div>

              <div className="kx-about__floating-card kx-about__floating-card--two">
                <span>Event status</span>
                <strong>
                  <i></i> Active
                </strong>
              </div>
            </div>
          </div>
        </section>

        {/* INTRO */}
        <section className="kx-about__intro">
          <div className="kx-about__section-inner">
            <div className="kx-about__intro-label">ABOUT KARAMALE</div>

            <div className="kx-about__intro-content">
              <h2>
                Built to put
                <br />
                <span>organisers in control.</span>
              </h2>

              <div className="kx-about__intro-copy">
                <p className="kx-about__lead">
                  Karamale is a smart, user-friendly ticketing platform that gives event organisers
                  the tools they need to create, launch and manage events while selling tickets
                  online and offline.
                </p>

                <p>
                  From professional event planners and promoters to independent organisers, Karamale
                  is designed for anyone who wants a simpler way to get an event from an idea to a
                  live audience.
                </p>

                <div className="kx-about__audience">
                  <span>Shows</span>
                  <span>Conferences</span>
                  <span>Parties</span>
                  <span>Festivals</span>
                  <span>Gatherings</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="kx-about__steps" id="how-it-works">
          <div className="kx-about__section-inner">
            <div className="kx-about__section-heading">
              <div>
                <span className="kx-about__eyebrow kx-about__eyebrow--dark">GET STARTED</span>

                <h2>
                  From idea to
                  <br />
                  <strong>live event.</strong>
                </h2>
              </div>

              <p>
                Getting started takes only a few steps. Once your account is verified, your
                organiser dashboard puts everything you need in one place.
              </p>
            </div>

            <div className="kx-about__step-grid">
              <div className="kx-about__step">
                <div className="kx-about__step-number">01</div>
                <div>
                  <h3>Sign up</h3>
                  <p>Create your organiser account and tell us a little about yourself.</p>
                </div>
              </div>

              <div className="kx-about__step">
                <div className="kx-about__step-number">02</div>
                <div>
                  <h3>Verify</h3>
                  <p>Confirm your account using the secure code sent to your email.</p>
                </div>
              </div>

              <div className="kx-about__step">
                <div className="kx-about__step-number">03</div>
                <div>
                  <h3>Launch</h3>
                  <p>Create your event, set your tickets and start selling to your audience.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ORGANISER DASHBOARD */}
        <section className="kx-about__product">
          <div className="kx-about__section-inner">
            <div className="kx-about__product-copy">
              <span className="kx-about__eyebrow">YOUR COMMAND CENTRE</span>

              <h2>
                Everything your
                <br />
                event needs.
              </h2>

              <p>
                Your organiser dashboard brings your event, tickets, sales and payouts together so
                you can focus on running the experience rather than chasing the numbers.
              </p>

              <div className="kx-about__feature-list">
                <div>
                  <span>01</span>
                  <strong>Create unlimited events</strong>
                </div>

                <div>
                  <span>02</span>
                  <strong>Set your own ticket prices</strong>
                </div>

                <div>
                  <span>03</span>
                  <strong>Track sales and payouts</strong>
                </div>
              </div>
            </div>

            <div className="kx-about__product-image">
              <div className="kx-about__image-window">
                <div className="kx-about__window-bar">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>

                <img src={dashboardImage} alt="Karamale organiser dashboard" />
              </div>
            </div>
          </div>
        </section>

        {/* MARKETING */}
        <section className="kx-about__marketing">
          <div className="kx-about__section-inner">
            <div className="kx-about__marketing-top">
              <div>
                <span className="kx-about__eyebrow kx-about__eyebrow--dark">
                  REACH YOUR AUDIENCE
                </span>

                <h2>
                  Your event deserves
                  <br />
                  <strong>an audience.</strong>
                </h2>
              </div>

              <p>
                Karamale gives organisers more than ticketing. Connect with your existing audience
                while putting your event in front of people already looking for something to do.
              </p>
            </div>

            <div className="kx-about__marketing-grid">
              <div className="kx-about__marketing-card">
                <span className="kx-about__marketing-number">01</span>
                <h3>Your contacts</h3>
                <p>Reach people already connected to your event through direct communication.</p>
              </div>

              <div className="kx-about__marketing-card kx-about__marketing-card--accent">
                <span className="kx-about__marketing-number">02</span>
                <h3>Karamale audience</h3>
                <p>Put your event where people can discover new experiences and upcoming events.</p>
              </div>

              <div className="kx-about__marketing-card">
                <span className="kx-about__marketing-number">03</span>
                <h3>Your lists</h3>
                <p>
                  Bring your own audience and communicate with the people who matter most to your
                  event.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* PRODUCT SHOWCASE */}
        <section className="kx-about__showcase">
          <div className="kx-about__section-inner">
            <div className="kx-about__showcase-heading">
              <span className="kx-about__eyebrow">THE ORGANISER EXPERIENCE</span>

              <h2>
                From creating your event
                <br />
                to seeing it <strong>go live.</strong>
              </h2>
            </div>

            <div className="kx-about__showcase-grid">
              <article className="kx-about__showcase-card kx-about__showcase-card--large">
                <div className="kx-about__showcase-image">
                  <img src={dashboardImage} alt="Karamale dashboard" />
                </div>

                <div className="kx-about__showcase-info">
                  <span>01 / DASHBOARD</span>
                  <h3>Your event command centre.</h3>
                </div>
              </article>

              <article className="kx-about__showcase-card">
                <div className="kx-about__showcase-image">
                  <img src={createEventImage} alt="Create an event on Karamale" />
                </div>

                <div className="kx-about__showcase-info">
                  <span>02 / CREATE</span>
                  <h3>Build your event.</h3>
                </div>
              </article>

              <article className="kx-about__showcase-card">
                <div className="kx-about__showcase-image">
                  <img src={eventListedImage} alt="Karamale listed event" />
                </div>

                <div className="kx-about__showcase-info">
                  <span>03 / LAUNCH</span>
                  <h3>Get your event listed.</h3>
                </div>
              </article>
            </div>
          </div>
        </section>

        {/* ANALYTICS */}
        <section className="kx-about__analytics">
          <div className="kx-about__section-inner">
            <div className="kx-about__analytics-heading">
              <div>
                <span className="kx-about__eyebrow">ALL THINGS ANALYTICS</span>

                <h2>
                  Know what's
                  <br />
                  <strong>happening.</strong>
                </h2>
              </div>

              <p>
                Keep an eye on performance as your event grows. Karamale gives you visibility into
                revenue, sales progress and overall event performance.
              </p>
            </div>

            <div className="kx-about__analytics-grid">
              <article>
                <div className="kx-about__analytics-image">
                  <img src={revenueImage} alt="Karamale revenue analytics" />
                </div>

                <span>REVENUE</span>
                <h3>See what your event is earning.</h3>
              </article>

              <article>
                <div className="kx-about__analytics-image">
                  <img src={salesImage} alt="Karamale sales progress" />
                </div>

                <span>SALES PROGRESS</span>
                <h3>Understand how ticket sales are moving.</h3>
              </article>

              <article>
                <div className="kx-about__analytics-image">
                  <img src={performanceImage} alt="Karamale performance analytics" />
                </div>

                <span>PERFORMANCE</span>
                <h3>Measure the bigger picture.</h3>
              </article>
            </div>
          </div>
        </section>

        {/* CAMPAIGN MODEL */}
        <section className="kx-about__campaign">
          <div className="kx-about__section-inner">
            <div className="kx-about__campaign-intro">
              <span className="kx-about__eyebrow kx-about__eyebrow--dark">THE CAMPAIGN MODEL</span>

              <h2>
                You decide how much
                <br />
                <strong>to put behind your event.</strong>
              </h2>

              <p>
                Creating events on Karamale is free. When you're ready to activate an event, you
                fund a campaign budget that powers the ticketing activity around it.
              </p>
            </div>

            <div className="kx-about__campaign-layout">
              <div className="kx-about__campaign-main">
                <div className="kx-about__campaign-big">
                  <span>SERVICE FEE</span>
                  <strong>3.5%</strong>
                  <p>
                    Applied to ticket sales against your campaign budget — not taken from your event
                    revenue.
                  </p>
                </div>

                <div className="kx-about__campaign-points">
                  <div>
                    <strong>R10+</strong>
                    <span>Campaign budget</span>
                  </div>

                  <div>
                    <strong>100%</strong>
                    <span>Event revenue</span>
                  </div>

                  <div>
                    <strong>LIVE</strong>
                    <span>Campaign insights</span>
                  </div>
                </div>
              </div>

              <div className="kx-about__campaign-side">
                <h3>What you can see</h3>

                <ul>
                  <li>Reach and impressions</li>
                  <li>Ticket admissions</li>
                  <li>Unique buyers</li>
                  <li>Remaining budget</li>
                  <li>Total expenditure</li>
                  <li>Real-time campaign activity</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* PROMOTERS */}
        <section className="kx-about__promoters">
          <div className="kx-about__section-inner">
            <div className="kx-about__promoters-copy">
              <span className="kx-about__eyebrow">BUILT FOR PROMOTERS</span>

              <h2>
                Give your promoters
                <br />
                <strong>their own lane.</strong>
              </h2>

              <p>
                Create unique promoter accounts, assign access and see exactly how each promoter is
                performing.
              </p>

              <div className="kx-about__promoter-list">
                <div>
                  <span>01</span>
                  <strong>Individual accounts</strong>
                </div>

                <div>
                  <span>02</span>
                  <strong>Sales by promoter</strong>
                </div>

                <div>
                  <span>03</span>
                  <strong>Income and ticket categories</strong>
                </div>

                <div>
                  <span>04</span>
                  <strong>Deactivate access anytime</strong>
                </div>
              </div>
            </div>

            <div className="kx-about__promoters-visual">
              <div className="kx-about__promoter-panel">
                <div className="kx-about__promoter-panel-head">
                  <span>PROMOTER PERFORMANCE</span>
                  <span>THIS EVENT</span>
                </div>

                <div className="kx-about__promoter-row">
                  <span className="kx-about__person">TM</span>
                  <div>
                    <strong>Thabo M.</strong>
                    <small>VIP / General</small>
                  </div>
                  <strong>248</strong>
                </div>

                <div className="kx-about__promoter-row">
                  <span className="kx-about__person">LN</span>
                  <div>
                    <strong>Lerato N.</strong>
                    <small>General</small>
                  </div>
                  <strong>193</strong>
                </div>

                <div className="kx-about__promoter-row">
                  <span className="kx-about__person">SK</span>
                  <div>
                    <strong>Sipho K.</strong>
                    <small>VIP</small>
                  </div>
                  <strong>117</strong>
                </div>

                <div className="kx-about__promoter-total">
                  <span>Total promoter sales</span>
                  <strong>558</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SCANNING */}
        <section className="kx-about__scanning">
          <div className="kx-about__section-inner">
            <div className="kx-about__scanning-visual">
              <div className="kx-about__phone">
                <div className="kx-about__phone-speaker"></div>

                <div className="kx-about__phone-screen">
                  <div className="kx-about__scan-brand">
                    karamale<span>.</span>
                  </div>

                  <div className="kx-about__scan-box">
                    <div className="kx-about__scan-corner scan-corner--tl"></div>
                    <div className="kx-about__scan-corner scan-corner--tr"></div>
                    <div className="kx-about__scan-corner scan-corner--bl"></div>
                    <div className="kx-about__scan-corner scan-corner--br"></div>
                    <div className="kx-about__scan-line"></div>
                  </div>

                  <strong>Scan ticket</strong>
                  <span>Position the QR code inside the frame</span>
                </div>
              </div>
            </div>

            <div className="kx-about__scanning-copy">
              <span className="kx-about__eyebrow">TICKET SCANNING</span>

              <h2>
                Your phone becomes
                <br />
                <strong>your scanner.</strong>
              </h2>

              <p>
                Karamale's dedicated scanning experience lets your team validate tickets at the door
                without expensive specialist hardware.
              </p>

              <div className="kx-about__scan-features">
                <div>
                  <span>✓</span>
                  <p>Every scan is tracked in real time.</p>
                </div>

                <div>
                  <span>✓</span>
                  <p>Invalid or already-scanned tickets are rejected.</p>
                </div>

                <div>
                  <span>✓</span>
                  <p>See attendance, no-shows and ticket categories.</p>
                </div>

                <div>
                  <span>✓</span>
                  <p>Support both physical and digital tickets.</p>
                </div>
              </div>

              <div className="kx-about__scan-note">
                <strong>Digital tickets</strong>
                <span>
                  capture attendee information such as name, email and phone for deeper event
                  insights.
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="kx-about__final">
          <div className="kx-about__final-inner">
            <div className="kx-about__final-mark">
              karamale<span>.</span>
            </div>

            <span className="kx-about__eyebrow kx-about__eyebrow--dark">READY WHEN YOU ARE</span>

            <h2>
              Create. Launch.
              <br />
              <strong>Sell.</strong>
            </h2>

            <p>Easy and simple. Ten minutes is all you need to get your event moving.</p>

            <Link to="/organiser-registration" className="kx-about__final-button">
              Create your event
              <span>→</span>
            </Link>
          </div>
        </section>
      </div>
    )
  }
}

export default Aboutkaramale
